/**
 * @Author: 左建
 * @Date: 2022/8/15 9:30
 * @LastEditTime: 2022/8/15 9:30
 * @Description: 机构首页相关
*/

import { post, postFormData } from "@/utils/request"

/**
 * @description 发送使用申请验证码
 * @param {string} tel - 电话号码
 * @return {Promise<unknown>}
 */

export function sendTrialCode (tel) {
    return post("Api/User/SendTrialCode", { tel })
}

/**
 * @description 试用申请表单提交
 * @param {object} params - params 参数
 * @return {Promise<unknown>}
 */
export function submitForm (params) {
    return post("/Api/User/TrialAdd", {
        model: JSON.stringify(params)
    }, false, {
        model: JSON.stringify(params)
    })
}
